import React from 'react';
import { Link } from 'react-router-dom';

const ProyectoPreview = ({ image, name, desc, slug }) => (
  <div className="col-md-6 col-lg-3 g-mb-30">
    <Link to={slug}>
      <div className="u-block-hover g-parent">
        <img
          className="img-fluid g-transform-scale-1_1--parent-hover g-transition-0_5 g-transition--ease-in-out"
          src={image}
          alt="Preview"
        />
        <div className="d-flex w-100 h-100 g-bg-black-opacity-0_6 opacity-0 g-opacity-1--parent-hover g-pos-abs g-top-0 g-left-0 g-transition-0_3 g-transition--ease-in u-block-hover__additional--fade u-block-hover__additional--fade-in g-pa-20">
          <ul className="align-items-end flex-column list-inline mt-auto ml-auto mb-0">
            <li className="list-inline-item">
              <i className="icon-communication-017 u-line-icon-pro"></i>
            </li>
          </ul>
        </div>
      </div>
      <div
        style={{ minHeight: '120px' }}
        className="u-shadow-v19 g-bg-white text-center g-pa-25 mb-1">
        <h3 className="h5 g-color-black g-font-size-16 g-font-weight-700 mb-1">{name}</h3>
        <p className="mb-0 g-color-gray-dark-v4 g-font-size-14">{desc}</p>
      </div>
    </Link>
  </div>
);

export default ProyectoPreview;



// WEBPACK FOOTER //
// ./src/subcomponents/ProyectoPreview.js